import type { ImproveMissingField } from '../../hooks/use-improve'

export function formatStrength(score: number): string {
  return `${Math.round(Math.max(0, Math.min(1, score)) * 100)}%`
}

export function missingLabelsPhrase(missing: ImproveMissingField[]): string {
  const labels = missing.map((row) => row.label.toLowerCase())
  if (labels.length <= 1) return labels.join('')
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}

export function ImproveMissingList({ missing }: { missing: ImproveMissingField[] }) {
  if (!missing.length) {
    return <p className="text-sm text-muted-foreground">Nothing structural is missing.</p>
  }
  return (
    <ul className="space-y-1.5">
      {missing.map((row) => (
        <li key={row.key} className="flex items-start gap-1.5 text-sm leading-snug">
          <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-muted-foreground/60" aria-hidden />
          <span>
            <span className="font-medium text-foreground">{row.label}</span>
            {row.hint ? <span className="text-muted-foreground"> — {row.hint}</span> : null}
          </span>
        </li>
      ))}
    </ul>
  )
}
